import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'accountingZero',
})
export class AccountingZeroPipe implements PipeTransform {
  transform(value: unknown): unknown {
    if (typeof value === 'number') {
      return Number.isInteger(value) ? `${value}.-` : value;
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();
      return /^[+-]?\d+$/.test(trimmed) ? `${trimmed}.-` : value;
    }

    return value;
  }
}
